// @flow
import NotFoundLoader from './500Loader';
export default NotFoundLoader;
